export default "__VITE_ASSET__DgTDB8Wy__"